export const selectMainDomain = state => state.whitelabel.mainDomain;
export const selectWhitelabelDomain = state => state.whitelabel.whitelabelDomain;
export const selectWhitelabelInfo = state => state.whitelabel.info